const actionTypes = require('constants/actionTypes');
const Immutable = require('immutable');

const setInitialState = () => {
    return Immutable.Map().merge({
        headerHidden: false,
        isSmallHeaderStyle: false,
        logo: {},
    });
};

const initialState = setInitialState();

const headerReducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case actionTypes.HIDE_HEADER:
            return state.merge({
                headerHidden: true,
            });

        case actionTypes.SHOW_HEADER:
            return state.merge({
                headerHidden: false,
            });

        case actionTypes.LOAD_LOGO:
            return state.merge({
                logo: action.customLogoNavbarUrl,
            });

        case actionTypes.SET_IS_SMALL_HEADER_STYLE:
            return state.merge({
                isSmallHeaderStyle: action.payload,
            });

        default:
            return state;
    }
};

module.exports = headerReducer;
